<template>
    <div>
        <v-offline online-class="online" offline-class="offline" @detected-condition="amIOnline">
            <template v-slot:[onlineSlot] :slot-name="onlineSlot">
                {{ onlineOfflineMsg }}
            </template>
            <template v-slot:[offlineSlot] :slot-name="offlineSlot">
                {{ onlineOfflineMsg }}
            </template>
        </v-offline>
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox ">
                    <div class="ibox-content">
                        <div class="row setMarginTop set_res_margin_top">
                            <div class="col-xs-12 col-md-12 col-xl-12">
                                <div class="row setTitleDiv">
                                    <div class="col-6">
                                        <p>Vaccination Areas</p>
                                    </div>
                                    <div class="col-6 text-right">
                                        <button class="btn btn-primary" type="button" @click="addVaccinationArea">Add Vaccination Area</button>
                                    </div>
                                </div>
                                <div class="row setMarginTop set_res_margin_top">
                                    <div class="col-xs-6 col-sm-12 col-md-6 col-xl-3">
                                        <span style="color: #4285f4;">Select Filter</span>
                                        <div class="form-group">
                                            <template>
                                                <el-select v-model="selectFilter" filterable placeholder="All"
                                                    class="el_select_width">
                                                    <el-option v-for="area in filterArrAreas" :key="area.id"
                                                        :label="area.name" :value="area.key">
                                                    </el-option>
                                                </el-select>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-sm-12 col-md-6 col-xl-3" v-if="!inputshow">
                                        <fg-input type="text" style="margin-top: 23px;" :placeholder="placeholderVal"
                                            name="selectFilterVal" v-model="selectFilterVal">
                                        </fg-input>
                                    </div>
                                    <div class="col-xs-6 col-sm-12 col-md-6 col-xl-3" v-if="!daterangPicker">
                                        <span style="color: #4285f4;">Select Date Range</span>
                                        <v-md-date-range-picker :presets="dateRangePresets"
                                            @change="handleChange"></v-md-date-range-picker>
                                    </div>
                                </div>
                                <br>
                                <p>Note: An area is considered submitted/closed when all individual
                                    assignments are submitted</p>
                                <div class="setMarginTop set_res_margin_top" v-if="filteredVaccinationArea.length == 0"
                                    style="text-align: center;">
                                    <p class="no_rec_msg">No Records found</p>
                                </div>
                            </div>
                            <div class="color-status-card" v-if="filteredVaccinationArea.length">
                                <!--                                            <get-stats />-->
                                <div class="row setMarginTop">
                                    <div class="col-xs-6 col-sm-12 col-md-4 col-xl-4 set_cursor"
                                        v-for="item in filteredVaccinationArea" :key="item.id"
                                        @click="areaDetail(item.id)">
                                        <area-card :areaId="item.id" :vaccination-count="item.vaccinations_count"
                                            :survey-count="item.surveys_count" :areaImage="item.areaImage"
                                            :title="item.name" :country="item.google_country"
                                            :createdOn="item.created_at"
                                            :areaState="item.google_admin_area_level1 != 'null' ? item.google_admin_area_level1 : 'Not specified'"
                                            :locality="item.google_locality != 'null' ? item.google_locality : 'Not specified'"
                                            :fieldUsers="item.assigned_areas" :colorStatus="item.status_color_code"
                                            :vaccinationStatus="item.status_info.vaccination"
                                            :surveyStatus="item.status_info.survey"></area-card>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import mixin from '../../../mixins/GlobalMixin';
import dateRangeDefaultPresetsMixin from '../../../mixins/DateRangeDefaultPresetsMixin';
import AreaCard from "../UIComponents/Cards/VaccinationRecordCard.vue";
import GetStats from '../../modules/GetStats.vue'
import { Select, Option, Dialog } from 'element-ui';
//import AreaCard from "./AssignAreaUsers.vue";
import Swal from 'sweetalert2';
import Vue from 'vue';
import VMdDateRangePicker from "v-md-date-range-picker";

Vue.use(VMdDateRangePicker);
import VOffline from 'v-offline';
import { Checkbox } from 'element-ui';

export default {
    components: {
        "area-card": AreaCard,
        [Option.name]: Option,
        [Select.name]: Select,
        [Checkbox.name]: Checkbox,
        [Dialog.name]: Dialog,
        VOffline,
        GetStats,
    },
    props: {
        projectId: {
            type: Number,
        }
    },
    data() {
        return {
            isReadOnly: false,
            areaId: '',
            title: '',
            createdOn: '',
            country: '',
            areaState: '',
            locality: '',
            fieldUsers: '',
            areaImage: '',

            selectFilter: "",
            selectFilterVal: "",
            selectedDistrict: [],
            selectedState: [],
            placeholderVal: "",
            project: null,

            area: [],
            filterArrAreas: [
                { id: 1, name: 'All', 'key': 'all' },
                { id: 2, name: 'Created On', 'key': 'created_at' },
                { id: 3, name: 'Modifed On', 'key': 'last_modified' },
                { id: 4, name: 'Country', 'key': 'country' },
                { id: 5, name: 'State/Province', 'key': 'google_admin_area_level1' },
                { id: 6, name: 'City/District/Village', 'key': 'google_locality' },
            ],
            stratDate: '',
            endDate: '',
            inputshow: true,
            daterangPicker: true,
            colorStatusWithText: [
                { color_code: 'grey', label: '0 Vaccination & 0 survery records' },
                { color_code: 'purple', label: '0 < vaccination & 0 survey records' },
                { color_code: 'yellow', label: '1 < vaccination & 1 < survey records' },
                { color_code: 'blue', label: ' Vaccination submitted & 0 survey records' },
                { color_code: 'pink', label: 'Vaccination submitted & 0 < survey records' },
                { color_code: 'red', label: 'Surveys submitted & survey ratio < target ratio' },
                { color_code: 'green', label: 'Surveys submitted & survey ratio is >= target ratio' },
            ],
            dateRangePresets: [],
        }
    },
    mixins: [mixin, dateRangeDefaultPresetsMixin],
    methods: {
        handleChange(values) {
            var sDate = this.formatDate(values[0]._d);
            var eDate = this.formatDate(values[1]._d);
            this.stratDate = sDate;
            this.endDate = eDate;
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
        getArea() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let vm = this;
            axios.get("/area?project_id=" + this.projectId)
                .then(response => {
                    if (response.data.response.error.error_code == 0) {
                        vm.area = response.data.response.data;
                    }
                    loading.close();
                })
                .catch(error => {
                    console.log(error);
                    loading.close();
                });
        },
        areaDetail(area_id) {
            Bus.$emit("area_id", area_id);
            //this.projectId = area_id;
            //window.location = '/project/area_details/' + this.projectId;
            this.$router.push({ name: 'viewAreaDetails', params: { projectId: this.projectId, areaId: area_id } })
        },
        getStatusColorCode() {
            axios.get('/area/status/color_codes').then(response => {
                this.colorStatusWithText = response.data.response.data;
                console.log('response', response.data.response);
            }).catch(err => {
            });
        },
        addVaccinationArea() {
            this.$router.push({ name: 'addVaccinationArea', params: { projectId: this.projectId } });
        }
    },
    computed: {
        filteredVaccinationArea: function () {
            if (this.area.length == 0) {
                return [];
            }
            var type = this.selectFilter;
            if (type == "country" || type == "google_admin_area_level1" || type == "google_locality") {
                this.daterangPicker = true;
                this.inputshow = false;
                if (type == "country") {
                    this.placeholderVal = "Enter Country";
                } else if (type == "google_admin_area_level1") {
                    this.placeholderVal = "Enter State/Province";
                } else if (type == "google_locality") {
                    this.placeholderVal = "Enter City/District/Village";
                }
                if (this.selectFilter && this.selectFilterVal) {
                    return this.area.filter(item => {
                        if (item[type] != null) {
                            return (
                                item[type].toLowerCase().indexOf(this.selectFilterVal.toLowerCase()) > -1
                            );
                        }
                    });
                } else {
                    return this.area.filter(item => {
                        return item
                    });
                }
            } else if (type == "last_modified" || type == "created_at") {
                this.inputshow = true;
                this.daterangPicker = false;
                try {
                    setTimeout(function () {
                        document.getElementsByClassName("bar")[0].nextElementSibling.textContent = '';
                    }, 50);
                } catch (e) {
                }
                if (this.selectFilter && this.stratDate && this.endDate) {
                    return this.area.filter(item => {
                        return (
                            new Date(this.formatDate(item[type])) >= new Date(this.stratDate) && new Date(this.formatDate(item[type])) <= new Date(this.endDate)
                        );
                    });
                } else {
                    return this.area.filter(item => {
                        return item
                    });
                }
            } else {
                this.daterangPicker = true;
                this.inputshow = true;
                return this.area.filter(item => {
                    return item
                });
            }
        }
    },
    mounted() {
        this.getArea();
        const vm = this;

        vm.isReadOnly = false
        vm.$store.getters.getUserRoleForCurrentProject.forEach(r => {
            if (r.role_name == 'VIEWER') {
                vm.isReadOnly = true
            }
        })

        vm.$store.dispatch("setScreenName", "Areas");
        vm.project = vm.$store.getters.getCurrentSelectedProject;

        vm.getStatusColorCode();
        vm.dateRangePresets = vm.getDateRangePresets();
    }
}

</script>
<style scoped>

.setTitleDiv p {
    font-size: 17px;
    font-weight: 600;
    color: black;
}

.el_select_width {
    width: 100% !important;
}

.no_rec_msg {
    font-size: 20px;
    height: 220px;
}

.set_cursor {
    cursor: pointer;
}

.color-status-card {
    padding: 5px 15px;
    width: 100%;
}
</style>
